import * as devis from './devisCommande/devis';
import * as client from './client/client';
import * as validation from './general/validation';

export const PAGES = {
  client: client.CLIENT,
  validation: validation.VALIDATION,
  validationDevis: devis.VALIDATION,
};

export const NOTHING = '';



// WEBPACK FOOTER //
// ./src/i18n/fr/import.js